export const CITY_LANDING_PAGE_IDS = ['pages_spb', 'pages_tyumen'];
